// vuex / store / state
export default {
  gapi: null,

  // # ms - new state
  // ---------------------
  msal: {
    app: null,
    accessToken: null,
    apiAccessToken: null,
    graphToken: null,
    homeId: null,
    config: {
      scopes: ['user.read', 'user.read.all'],
      graphScopes: ['user.read', 'user.read.all'],
      apiScope: process.env.VUE_APP_AZURE_API_SCOPE || 'api://637c2e1b-3c98-422c-9de6-8d56c7442697/access_as_user',
      clientId: process.env.VUE_APP_AZURE_CLIENT_ID || '637c2e1b-3c98-422c-9de6-8d56c7442697',
      tenantId: process.env.VUE_APP_AZURE_TENANT_ID || '6ac7a1f4-5fb1-4153-bb4f-12d2020a1f7d',
      redirectUri: process.env.VUE_APP_AZURE_REDIRECT_URI || null
    },
    graphApi: 'https://graph.microsoft.com/v1.0',
    api: 'https://graph.microsoft.com/beta'
  },
  // ---------------------

  user: {
    email: null,
    // # ms - change
    // GgId: null,
    msId: null,
    Name: null,
    Avatar: null,
    Role: null,
    transfer_Role: null,
    ci_Role: null,
    bases_Role: null,
    lock: null
    // RoleType: null,
  },
  userCaches: [],
  barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
  barImage: '',
  drawer: null
}
